

(() => {
  const section = document.querySelector('.product-hearth');
  if (!section) return;

  const defaultColor = section.dataset.defaultColor;
  const buttons = section.querySelectorAll('.product-hearth__color');
  const visuals = section.querySelectorAll('.product-hearth__visual');
  const label = section.querySelector('[data-color-label]');
  const wraps = section.querySelectorAll('.color-wrap');
  const liveRegion = section.querySelector('[data-color-live]');

  let active = null;

  const colorMap = {
    light: 'Light wood',
    white: 'Matte white',
    black: 'Matte black'
  };

  function resetToDefault() {
    active = null;
    label.textContent = defaultColor;

    visuals.forEach(v => {
      v.hidden = v.dataset.visual !== 'default';
    });

    wraps.forEach(w => w.classList.remove('is-active'));
    buttons.forEach(b => {
      b.classList.remove('is-active');
      b.setAttribute('aria-checked', 'false');
    });

    if (liveRegion) {
      liveRegion.textContent = 'Color selection cleared';
    }
  }

  function activateColor(btn) {
    const color = btn.dataset.color;
    const wrap = btn.closest('.color-wrap');

    // Permite deseleccionar (tu lógica original)
    if (active === color) {
      resetToDefault();
      return;
    }

    active = color;
    label.textContent = colorMap[color];

    visuals.forEach(v => {
      v.hidden = v.dataset.visual !== color;
    });

    wraps.forEach(w => w.classList.remove('is-active'));
    buttons.forEach(b => {
      b.classList.remove('is-active');
      b.setAttribute('aria-checked', 'false');
    });

    wrap.classList.add('is-active');
    btn.classList.add('is-active');
    btn.setAttribute('aria-checked', 'true');

    if (liveRegion) {
      liveRegion.textContent = `Color changed to ${colorMap[color]}`;
    }
  }

  buttons.forEach((btn, index) => {
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-checked', 'false');

    btn.addEventListener('click', () => {
      activateColor(btn);
    });

    btn.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();

        const newIndex =
          e.key === 'ArrowRight' ? index + 1 : index - 1;

        if (newIndex >= 0 && newIndex < buttons.length) {
          buttons[newIndex].focus();
        }
      }
    });


  });
})();


